import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import * as constants from '../constants/profile-constants';

import type {List} from 'immutable';

export type ProfileStore = {
    activity: List<unknown>;
    organizations: List<unknown>;
};

const initialState = () => {
    return {
        activity: Immutable.List(),
        organizations: Immutable.List(),
    };
};

const actionsMap = {
    [constants.PROFILE_HISTORY_SUCCESS]: (state, action) => {
        return {
            activity: action.data,
        };
    },

    [constants.PROFILE_ORGANIZATIONS_SUCCESS]: (state, action) => {
        return {
            organizations: action.data,
        };
    },

    [constants.DISPOSE_PROFILE_STORE]: () => {
        return initialState();
    },
};

export default createReducer<ProfileStore>(initialState(), actionsMap);
